import React from 'react'
import { useSelector } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'

import { getBill, getEmail } from '../../../../redux/slices/userSlice'

const ProtectedRoute = ({ component: Component, bill, ...rest }) => {
	const isAuthorized = useSelector(getEmail)
	const isBill = useSelector(getBill)
	if (bill) {
		return (
			<Route
				{...rest}
				render={props => {
					if (isAuthorized && isBill) {
						return <Component {...rest} {...props} />
					} else {
						return <Redirect to="/" />
					}
				}}
			/>
		)
	}
	return (
		<Route {...rest} render={props => <Component {...rest} {...props} />} />
	)
}

export { ProtectedRoute }
